// Constants for Tax Document List API actions.
export const GET_TAX_DOCUMENT_LIST = 'GET_TAX_DOCUMENT_LIST';
export const GET_TAX_DOCUMENT_LIST_SUCCESS = 'GET_TAX_DOCUMENT_LIST_SUCCESS';
export const GET_TAX_DOCUMENT_LIST_FAILURE = 'GET_TAX_DOCUMENT_LIST_FAILURE';

// Constants for Tax Document API actions will go here..
export const GET_TAX_DOCUMENT = 'GET_TAX_DOCUMENT';
export const GET_TAX_DOCUMENT_SUCCESS = 'GET_TAX_DOCUMENT_SUCCESS';
export const GET_TAX_DOCUMENT_FAILURE = 'GET_TAX_DOCUMENT_FAILURE';